'use strict';

Odigeo.defineWidget('post_booking', Odigeo.Widget.extend({
    viewClass: require('../modules/views/post_booking'),

    bookingNotFound: function() {
        this.view.showBookingNotFound();
    },
}));
